import { request } from '@tencent/ppd-base-libs';
import { wxBridge } from '@tencent/wphk-base-wx';
// 初始化微信
export const setUpWeixin = () => wxBridge.weiXinInit({
  openTagList: ['wx-open-launch-weapp', 'wx-open-subscribe'],
  getTicket: async () => {
    const params = {
      url: location.href.split('#')[0],
      app_name: 'hk_life',
      // hk_prom – wxd82e1d3dfccffe5e
      // hk_life – wx9a52ebdae52f710f
    };
    // 这里为了配合订阅「wphk好生活」，需要调这个cgi
    return request
      .get('https://prom.wechatpay.com.hk/app/promotion/appid_jsapi_signature.cgi', {
        params,
      })
      .then((res) => {
        if (!res || res.retcode !== '0') {
          return;
        }
        return {
          appId: res.appId,
          nonceStr: res.nonceStr,
          signature: res.signature,
          timestamp: res.timeStamp,
        };
      });
  },
});
